(ns pfo.weblink.core
  (:require [secretary.core :as secretary :refer-macros [defroute]]
            [promesa.core :as p]
            [pfo.weblink.model :as model]
            [pfo.common.component :refer [empty-page]]
            [pfo.api :refer [process-error]]
            [pfo.util :as util]))



(defroute "/link/:version/:data/" [version data]
  (->> (model/direct-link version data)
       (p/map (fn [response]
                (util/set-location (:url response))))
       (process-error))
  (util/set-initial-page empty-page))
